import { useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

export function useContextUsage(conversationId) {
  return useQuery({
    queryKey: ["context-usage", conversationId],
    queryFn: async () => (await apiClient.get(`/conversations/${conversationId}/context-usage`)).data,
    enabled: !!conversationId,
  });
}

// Gasto de la IA de este chat (tokens y USD). `refreshKey` cambia con cada mensaje (los tokens del contexto): así se vuelve a pedir justo después de cada respuesta.
export function useConversationSpend(conversationId, refreshKey) {
  return useQuery({
    queryKey: ["conversation-spend", conversationId, refreshKey],
    queryFn: async () => (await apiClient.get(`/conversations/${conversationId}/spend`)).data,
    enabled: !!conversationId,
    keepPreviousData: true,
    retry: false,
  });
}

export function useSetContextUsage() {
  const queryClient = useQueryClient();
  return (conversationId, data) => {
    if (!conversationId || !data) return;
    queryClient.setQueryData(["context-usage", conversationId], data);
  };
}
